module.exports = __webpack_public_path__ + "static/media/Bharat-Messenger.6f73e9f1.png";